import { createStore } from 'effector';
import { pending } from 'patronum';
import { getLegalsDocumentsFx } from './effects';
import { LegalDocument } from './entities';

export const $legalsDocuments = createStore<LegalDocument[]>([]);

export const $pendingLegals = pending({ effects: [getLegalsDocumentsFx] });
